import { Alert, CircularProgress, Fade, Snackbar, Typography } from '@mui/material';
import '../../styles/Login.css';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearUserSession } from '@src/helpers/ApiHelper';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import { setCurrentUser } from '@src/store/reducers/currentUserReducer';
import { setTemplates } from '@src/store/reducers/templatesReducer';
import {
	setRestaurants as setRestaurantRedux,
	setDefaultRestaurant,
} from '@src/store/reducers/branchReducer';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { AxiosError, AxiosResponse } from 'axios';
import SearchBar from '../SearchBar';
import { RESTAURANT } from '@src/Constants';
import { truncateField } from '@src/helpers/Helpers';
import { IsMobileWidth } from '../MediaQueryUtils';
import AvatarMenu from '../CustomAvatar/AvatarMenu';

export interface Restaurants {
	email: string;
	customer_id: string;
	last_name: string;
	first_name: string;
	telephone: string;
	photo: string;
	address: string;
	name: string;
	id: string;
}

const Restaurant = () => {
	const [isOffline, setIsOffline] = useState(false);
	const { apiService }: any = React.useContext(ApplicationContext);
	const [loading, setLoading] = useState(false);
	const [branches, setBranches] = useState<Restaurants[]>([]);
	const [filteredBranches, setFilteredBranches] = useState<any>();
	const [selectedValue, setSelectedValue] = useState<string>();
	const [searchInput, setSearchInput] = useState('');
	const [pageLoading, setPageLoading] = useState(true);

	const currentUser: any = useAppSelector((state) => state.currentUser.value);
	const restaurants: any = useAppSelector((state) => state?.restaurant?.value?.restaurants);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const isMobileWidth = IsMobileWidth();

	// const handleSelectChange = (e: SelectChangeEvent) => {
	// 	console.log(e);
	// 	// setSelectedValue(e.target.value as string);
	// };

	const handleSelect = (id: string) => {
		setSelectedValue(id as string);
		selectOrganizationAndNavigate(id as string);
	};
	const selectOrganizationAndNavigate = (value: string) => {
		if (currentUser?.type?.toLowerCase() === RESTAURANT) {
			const selectedRestaurant = branches?.find((res) => res?.id === value);
			dispatch(setDefaultRestaurant(selectedRestaurant));
			navigate(`/restaurants/${selectedRestaurant?.id}`);
		} else {
			const selectedRestaurant = branches?.find((res) => res?.id === value);
			dispatch(setDefaultRestaurant(selectedRestaurant));
			navigate(`/suppliers/${selectedRestaurant?.id}`);
		}
	};
	const handleSearch = (val: any) => {
		setSearchInput(val);
	};

	useEffect(() => {
		if (searchInput) {
			const filteredData = branches?.filter(
				({ name, address }) =>
					name.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase()) ||
					address.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase())
			);
			setFilteredBranches(filteredData);
		} else {
			setFilteredBranches(branches);
		}
	}, [branches, searchInput]);

	const logOut = () => {
		clearUserSession(undefined, undefined, navigate);

		// TODO: Consider calling it in clearUserSession method
		dispatch(setCurrentUser({}));
		dispatch(setTemplates({}));
	};

	const navigateToApp = (data: any, path: string) => {
		dispatch(setDefaultRestaurant(data?.[0]));
		navigate(path);
	};

	useEffect(() => {
		try {
			if (currentUser?.type?.toLowerCase() === RESTAURANT) {
				setLoading(true);
				apiService.getRestaurants(
					(response: AxiosResponse) => {
						const data = response?.data?.data;
						if (data?.length === 1) {
							navigateToApp(data, `/restaurants/${data?.[0]?.id}`);
						}
						setSelectedValue(data[0]?.id);
						dispatch(setRestaurantRedux(data));
						setBranches(data);
						setLoading(false);
						setPageLoading(false);
					},
					(error: AxiosError) => {
						setLoading(false);
						setPageLoading(false);
						console.log(restaurants);
						if (!navigator?.onLine) {
							console.log(restaurants);
							setBranches(restaurants);
						}
						if (error.response) {
							// Current status code for incorrect credentials must be changed to 401 or 403
							// if ([400, 401, 403].includes(error.response.status)) {
							// 	clearUserSession(undefined, undefined, navigate);
							// }
						}
					}
				);
			} else {
				apiService.getAllSuppliers(
					(response: AxiosResponse) => {
						const data = response?.data?.data;
						if (data?.length === 1) {
							navigateToApp(data, `/suppliers/${data?.[0]?.id}`);
						}
						setSelectedValue(data[0]?.id);
						dispatch(setRestaurantRedux(data));
						setBranches(data);
						setLoading(false);
						setPageLoading(false);
					},
					(error: AxiosError) => {
						setLoading(false);
						setPageLoading(false);
						if (!navigator?.onLine) {
							setBranches(restaurants);
						}
						if (error.response) {
							// Current status code for incorrect credentials must be changed to 401 or 403
							// if ([400, 401, 403].includes(error.response.status)) {
							// 	clearUserSession(undefined, undefined, navigate);
							// }
						}
					}
				);
			}
		} catch (err) {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		if (!navigator?.onLine) {
			setIsOffline(true);
		}
		const handleOnlineStatusChange = () => {
			setIsOffline(!navigator?.onLine);
		};

		window.addEventListener('online', handleOnlineStatusChange);
		window.addEventListener('offline', handleOnlineStatusChange);

		return () => {
			window.removeEventListener('online', handleOnlineStatusChange);
			window.removeEventListener('offline', handleOnlineStatusChange);
		};
	}, []);

	const handleClose = () => {
		setIsOffline(false);
	};

	if (isMobileWidth) {
		return (
			<div
				style={{ paddingTop: '36px', background: '#FDFDFD' }}
				className="select__restaurant__container"
			>
				{!pageLoading ? (
					<Fade in={true}>
						<div className="restaurant__body ">
							{!loading ? (
								<>
									<div
										className="login__body__logoWrapper"
										style={{ display: 'flex', alignItems: 'center' }}
									>
										<div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
											<img className="restaurant__body__logo" src="/ylPartsLogo.png" alt="Logo" />
										</div>
										<div>
											<AvatarMenu settingsIcon />
										</div>
									</div>
									<div
										style={{
											marginTop: '40px',
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
										}}
									>
										<div
											style={{
												marginBottom: '40px',
											}}
										>
											<div className="restaurant__body__content">
												<Typography
													variant="h2"
													sx={{
														fontSize: '18px',
														textAlign: 'center',
														mb: '6px',
													}}
												>
													{`Select The ${
														currentUser?.type?.toLowerCase() === RESTAURANT ? 'Dealer' : 'Supplier'
													} To Manage`}
												</Typography>
												<Typography
													sx={{
														fontSize: '14px',
														textAlign: 'center',
														maxWidth: '360px',
														color: '#7D7D7D',
														// mb: '40px',
													}}
													variant="body1"
												>
													{`The ${
														currentUser?.type?.toLowerCase() === RESTAURANT
															? 'restaurants'
															: 'suppliers'
													}
												under your management authorization are listed below. Kindly click on one of
												them to proceed`}
												</Typography>
											</div>

											<SearchBar
												style={{ width: '320px' }}
												placeholder={
													currentUser?.type?.toLowerCase() === RESTAURANT
														? 'Search Dealer'
														: 'Search Supplier'
												}
												value={searchInput}
												isLoading={false}
												onChange={(val) => handleSearch(val)}
											/>
										</div>

										<div
											style={{
												display: 'grid',
												gridTemplateColumns: 'repeat(2, 1fr)',
												gap: '10px 5px',
												width: '100%',
											}}
										>
											{filteredBranches?.length > 0 ? (
												filteredBranches?.map(
													(restaurant: {
														id: string;
														image: string;
														name: string;
														address: string;
														unReadMessagesCount: number;
													}) => (
														<div
															className="restaurant__mobile_card__container"
															style={{ display: 'flex', width: '153px', height: '186px' }}
															key={restaurant?.id}
															onClick={(e) => handleSelect(restaurant?.id)}
														>
															{restaurant?.unReadMessagesCount > 0 ? (
																<div className="card__notification__wrapper">
																	{restaurant?.unReadMessagesCount}
																</div>
															) : null}

															<img
																src={restaurant?.image || '/placeholderImage.svg'}
																width={70}
																height={70}
																style={{
																	position: 'absolute',
																	top: '12px',
																	left: '12px',
																	borderRadius: '50%',
																	boxShadow: '0px 18px 20px 0px #0000000d',
																}}
																alt={restaurant?.name}
															/>

															<div
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '4px',
																	textAlign: 'left',
																	width: '100%',
																	marginLeft: '16px',
																	marginBottom: '16px',
																}}
															>
																<div
																	style={{
																		color: '#1A1D1F',
																		fontWeight: 600,
																		fontSize: '13px',
																		maxWidth: '140px',
																		overflow: 'hidden',
																		whiteSpace: 'nowrap',
																		textOverflow: 'ellipsis',
																	}}
																>
																	{restaurant?.name}
																</div>

																<div
																	style={{
																		color: '#333333',
																		fontWeight: 500,
																		fontSize: '9px',
																		maxWidth: '140px',
																		display: '-webkit-box',
																		WebkitLineClamp: 3,
																		WebkitBoxOrient: 'vertical',
																		overflow: 'hidden',
																		textOverflow: 'ellipsis',
																	}}
																>
																	{restaurant?.address}
																</div>
															</div>
														</div>
													)
												)
											) : (
												<div
													style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														width: '100%',
														color: '#7D7D7D',
													}}
												>
													{currentUser?.type?.toLowerCase() === RESTAURANT
														? 'No restaurant found.'
														: 'No supplier found.'}
												</div>
											)}
										</div>

										{/* <Select
										variant="standard"
										labelId="demo-simple-select-outlined-label"
										onChange={(e) => handleSelectChange(e)}
										value={selectedValue}
										label="Language"
										style={{ width: '100%' }}
									>
										{organizations?.map((organization) => (
											<MenuItem key={organization?._id} value={organization?._id}>
												{organization?.name}
											</MenuItem>
										))}
									</Select> */}
									</div>
									{/* <Button
									onClick={selectOrganizationAndNavigate}
									size="large"
									variant="contained"
									color="primary"
									fullWidth
									disableElevation
									style={{ marginTop: '30px' }}
								>
									Continue
								</Button> */}
									{/* </Button> */}
									{/* <div className="login__body__versionWrapper">
									<SudofyBranding />
								</div> */}
								</>
							) : (
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<CircularProgress />
								</div>
							)}
						</div>
					</Fade>
				) : (
					<div className="progress">
						<CircularProgress color="primary" />
					</div>
				)}
				<Snackbar
					open={isOffline}
					onClose={handleClose}
					autoHideDuration={6000}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Alert severity="warning" variant="filled">
						You are currently offline. Some features may be unavailable.
					</Alert>
				</Snackbar>
			</div>
		);
	}
	return (
		<div className="select__restaurant__container">
			{!pageLoading ? (
				<Fade in={true}>
					<div className="restaurant__body ">
						{!loading ? (
							<>
								<div
									className="login__body__logoWrapper"
									style={{ display: 'flex', alignItems: 'center' }}
								>
									<div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
										<img className="restaurant__body__logo" src="/ylPartsLogo.png" alt="Logo" />
									</div>
									<div>
										<AvatarMenu settingsIcon />
									</div>
								</div>
								<div
									style={{
										marginTop: '40px',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
									}}
								>
									<div
										style={{
											marginBottom: '40px',
										}}
									>
										<div className="restaurant__body__content">
											<Typography
												variant="h2"
												sx={{
													textAlign: 'center',
													mb: '12px',
													'@media (max-width: 638px)': {
														fontSize: '18px',
													},
												}}
											>
												{`Select The ${
													currentUser?.type?.toLowerCase() === RESTAURANT ? 'Dealer' : 'Supplier'
												} To Manage`}
											</Typography>
											<Typography
												sx={{
													textAlign: 'center',
													maxWidth: '486px',
													color: '#7D7D7D',
													// mb: '40px',
													'@media (max-width: 638px)': {
														maxWidth: '100%',
													},
												}}
												variant="body1"
											>
												{`The ${
													currentUser?.type?.toLowerCase() === RESTAURANT
														? 'restaurants'
														: 'suppliers'
												}
												under your management authorization are listed below. Kindly click on one of
												them to proceed`}
											</Typography>
										</div>
										<div className="restaurant__searchbar__container">
											<SearchBar
												placeholder={
													currentUser?.type?.toLowerCase() === RESTAURANT
														? 'Search Dealer'
														: 'Search Supplier'
												}
												value={searchInput}
												isLoading={false}
												onChange={(val) => handleSearch(val)}
											/>
										</div>
									</div>
									<div className="cards_wrapper">
										{filteredBranches?.length > 0 ? (
											filteredBranches?.map(
												(restaurant: {
													id: string;
													image: string;
													name: string;
													address: string;
													unReadMessagesCount: number;
												}) => (
													<div
														className="restaurant__card__container"
														style={{ display: 'flex', width: '285px', height: '309px' }}
														key={restaurant?.id}
														onClick={(e) => handleSelect(restaurant?.id)}
													>
														{restaurant?.unReadMessagesCount > 0 ? (
															<div className="card__notification__wrapper">
																{restaurant?.unReadMessagesCount}
															</div>
														) : null}

														<div className="card__logo__wrapper">
															<img
																src={restaurant?.image || '/placeholderImage.svg'}
																width={100}
																height={100}
																alt={restaurant?.name}
															/>
														</div>
														<div className="card__content">
															<Typography
																sx={{
																	textAlign: 'left',
																	maxWidth: '486px',
																	mb: '4px',
																	width: '260px',
																	overflow: 'hidden',
																	whiteSpace: 'nowrap',
																	textOverflow: 'ellipsis',
																}}
																variant="subtitle1"
															>
																{restaurant?.name}
															</Typography>

															<Typography
																sx={{
																	textAlign: 'center',
																	maxWidth: '486px',
																	mb: '24px',
																	display: '-webkit-box',
																	WebkitLineClamp: 3,
																	WebkitBoxOrient: 'vertical',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis',
																}}
																variant="body2"
															>
																{restaurant?.address}
															</Typography>
														</div>
													</div>
												)
											)
										) : (
											<div
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													width: '100%',
													color: '#7D7D7D',
												}}
											>
												{currentUser?.type?.toLowerCase() === RESTAURANT
													? 'No restaurant found.'
													: 'No supplier found.'}
											</div>
										)}
									</div>
									{/* <Select
										variant="standard"
										labelId="demo-simple-select-outlined-label"
										onChange={(e) => handleSelectChange(e)}
										value={selectedValue}
										label="Language"
										style={{ width: '100%' }}
									>
										{organizations?.map((organization) => (
											<MenuItem key={organization?._id} value={organization?._id}>
												{organization?.name}
											</MenuItem>
										))}
									</Select> */}
								</div>
								{/* <Button
									onClick={selectOrganizationAndNavigate}
									size="large"
									variant="contained"
									color="primary"
									fullWidth
									disableElevation
									style={{ marginTop: '30px' }}
								>
									Continue
								</Button> */}
								{/* </Button> */}
								{/* <div className="login__body__versionWrapper">
									<SudofyBranding />
								</div> */}
							</>
						) : (
							<div style={{ display: 'flex', justifyContent: 'center' }}>
								<CircularProgress />
							</div>
						)}
					</div>
				</Fade>
			) : (
				<div className="progress">
					<CircularProgress color="primary" />
				</div>
			)}
			<Snackbar
				open={isOffline}
				onClose={handleClose}
				autoHideDuration={6000}
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			>
				<Alert severity="warning" variant="filled">
					You are currently offline. Some features may be unavailable.
				</Alert>
			</Snackbar>
		</div>
	);
};

export default Restaurant;
